import React from "react";
import { TextField, InputAdornment, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";

interface ContainerSearchProps {
  searchTerm: string;
  onSearchChange: (term: string) => void;
}

const ContainerSearch: React.FC<ContainerSearchProps> = ({
  searchTerm,
  onSearchChange,
}) => (
  <TextField
    label="Search containers"
    placeholder="Type at least 3 chars…"
    variant="outlined"
    size="small"
    fullWidth
    value={searchTerm}
    onChange={(e) => onSearchChange(e.target.value)}
    InputProps={{
      endAdornment: searchTerm ? (
        <InputAdornment position="end">
          <IconButton
            aria-label="clear search"
            onClick={() => onSearchChange("")}
            edge="end"
            size="small"
          >
            <ClearIcon fontSize="small" />
          </IconButton>
        </InputAdornment>
      ) : null,
    }}
  />
);

export default ContainerSearch;